import { makeVar } from '@apollo/client';

export const globalClassesNotificationVar = makeVar<string | undefined>(
  undefined
);
